



























    import { defineComponent, computed, PropType, ref } from "@vue/composition-api";
    import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import { alarm, sensor } from "../../../store";

    export default defineComponent({
        components: {
            SensorHeader: () =>
                import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
            SensorModule: () =>
                import(/* webpackChunkName: "components" */ "./SensorModule.vue"),
            EnrollDialog: () =>
                import(/* webpackChunkName: "settings" */ "../Dialogs/EnrollDialog.vue"),
            ConfirmDialog: () =>
                import(/* webpackChunkName: "settings" */ "../Dialogs/ConfirmDialog.vue")
        },
        props: {
            icon: { type: String, required: true },
            img: { type: String, required: true },
            withMute: { type: Boolean, default: false },
            showStatusText: { type: Boolean, default: false },
            value: Object as PropType<AttachedDeviceModel>
        },
        setup(props, { emit }) {
            const paired = computed<boolean>(() => {
                if (
                    props.value &&
                    props.value.attachedDeviceId &&
                    props.value.attachedDeviceId !== ""
                ) {
                    return true;
                } else {
                    return false;
                }
            });
            const showEnroll = ref(false);

            const showSuccess = computed<boolean>(() => {
                return alarm.deviceAdded;
            });

            const showTimeout = computed<boolean>(() => {
                return alarm.deviceTimedOut;
            });

            const successOk = () => {
                alarm.SetNewDeviceAdded(false);
                sensor.GetData();
            };

            const timeoutOk = () => {
                alarm.SetNewDeviceTimedOut(false);
                sensor.GetData();
            };

            const imgSrc = computed(() => {
                return require(`@/assets/img/${props.img}.png`);
            });
            const onEnroll = () => {
                showEnroll.value = true;
            };
            return {
                onEnroll,
                paired,
                showEnroll,
                showSuccess,
                successOk,
                showTimeout,
                timeoutOk,
                imgSrc
            };
        }
    });
